import React, { useState } from "react";
import Layout from "../layout/Layout";
import Phase1 from "./Phase1";
import Phase2 from "./Phase2";
import Phase3 from "./Phase3";
import Phase4 from "./Phase4";
import Phase5 from "./Phase5";
import { MdOutlineNavigateNext, MdOutlineNavigateBefore } from "react-icons/md";

const pages = [Phase1, Phase2, Phase3, Phase4, Phase5];

const Slider = () => {
  const [currentPage, setCurrentPage] = useState(0);

  const nextPage = () => {
    if (currentPage < pages.length - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const previousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const PageComponent = pages[currentPage];
  return (
    <Layout>
    
      <div className="container mx-auto  p-4">
        <PageComponent />
        <div className="flex justify-between  mt-4">
          <div
            onClick={previousPage}
            className={`${
              currentPage === 0 ? "hidden" : ""
            } hover:underline flex  cursor-pointer text-[21px] text-[#22345C] font-bold font-sans py-2 px-4 rounded`}
            // className="hover:underline flex  cursor-pointer text-[#22345C] font-semibold font-sans py-2 px-4 rounded"
          >
            <span>
              <MdOutlineNavigateBefore size={35} />
            </span>
            Click Here For Previous Phase
          </div>
          <div
            onClick={nextPage}
            className={`${
              currentPage === pages.length - 1 ? "hidden" : ""
            } hover:underline flex text-[#22345C]  cursor-pointer font-bold text-[21px] font-sans py-2 px-4 rounded`}
            // className="hover:underline flex text-[#22345C]  cursor-pointer font-semibold font-sans py-2 px-4 rounded"
          >
            Click Here For Next Phase{" "}
            <span>
              <MdOutlineNavigateNext size={35} />
            </span>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Slider;
